/**
 * Centralised route paths so callers don't sprinkle string literals across
 * the codebase. Keep these in sync with src/routes/* file-based routes.
 */
export const ROUTES = {
  login: "/login",
  overview: "/",
  users: "/users",
  userDetail: (userId: string) =>
    `/users?userId=${encodeURIComponent(userId)}`,
  memberships: "/memberships",
  hardware: "/hardware",
  // Outbound: the shipment list and the only two lost-in-transit actions (WF-57).
  fulfillment: "/fulfillment",
  reclaims: "/reclaims",
  fraud: "/fraud",
  disputes: "/disputes",
  supportActions: "/support-actions",
  dunningNotices: "/dunning-notices",
  auditLogs: "/audit-logs",
  // Finance: remaining gifted membership. Under /reports rather than beside the
  // ops screens because it is an accounting surface with its own permission,
  // not part of the day-to-day queue work.
  giftObligations: "/reports/gift-obligations",
  // WS-7: support's gift lookup + actions (Auth Brief §14 line 317).
  giftSupport: "/gifts",
  webhookHealth: "/webhook-health",
  settings: "/settings",
} as const;

export type AdminRoutePath =
  | "/login"
  | "/"
  | "/users"
  | `/users/${string}`
  | "/memberships"
  | "/hardware"
  | "/fulfillment"
  | "/reclaims"
  | "/fraud"
  | "/disputes"
  | "/support-actions"
  | "/dunning-notices"
  | "/audit-logs"
  | "/reports/gift-obligations"
  | "/gifts"
  | "/webhook-health"
  | "/settings";
